// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalWrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  overflow: hidden;
  height: 100vh;
}

.modal {
  background-color: white;
  height: min(90%, 480px);
  width: min(90%, 800px);
  border-radius: 0.15rem;
  display: block;
  position: static;
}

.modalHeader,
.modalFooter {
  display: flex;
  justify-content: end;
  align-items: center;
}

.modalContent {
  height: 90%;
  overflow-y: auto;
}

.modalHeader,
.modalFooter,
.modalContent {
  width: 100%;
  padding: 0.5rem 1rem;
}

.modalHeader {
  border-radius: 0.15rem 0.15rem 0 0;
  height: 10%;
  font-weight: bold;
  color: white;
  border-bottom: 1px solid #000000;
  background-color: rgb(34, 80, 138);
}

.modal button {
  margin: 0 0.25rem;
  font-size: 1.1rem;
}

.modal button#crossDiv {
  font-size: 2rem;
  background-color: transparent;
  border: none;
  color: #666;
}

.modal button.white {
  color: #fff !important;
}

.modalFooter {
  padding: 0.5rem;
  border-radius: 0 0 0.15rem 0.15rem;
}

.modalContent::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.modalContent {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC","sourcesContent":[".modalWrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgb(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  overflow: hidden;\n  height: 100vh;\n}\n\n.modal {\n  background-color: white;\n  height: min(90%, 480px);\n  width: min(90%, 800px);\n  border-radius: 0.15rem;\n  display: block;\n  position: static;\n}\n\n.modalHeader,\n.modalFooter {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.modalContent {\n  height: 90%;\n  overflow-y: auto;\n}\n\n.modalHeader,\n.modalFooter,\n.modalContent {\n  width: 100%;\n  padding: 0.5rem 1rem;\n}\n\n.modalHeader {\n  border-radius: 0.15rem 0.15rem 0 0;\n  height: 10%;\n  font-weight: bold;\n  color: white;\n  border-bottom: 1px solid #000000;\n  background-color: rgb(34, 80, 138);\n}\n\n.modal button {\n  margin: 0 0.25rem;\n  font-size: 1.1rem;\n}\n\n.modal button#crossDiv {\n  font-size: 2rem;\n  background-color: transparent;\n  border: none;\n  color: #666;\n}\n\n.modal button.white {\n  color: #fff !important;\n}\n\n.modalFooter {\n  padding: 0.5rem;\n  border-radius: 0 0 0.15rem 0.15rem;\n}\n\n.modalContent::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.modalContent {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
